import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'
import { Sort } from '@angular/material/sort'

import { Maksutapa } from '@lemon/core-firebase/model/tosite'
import { LocalStorageService } from '../../../_jaettu-angular/service/local-storage.service'

export interface TositeListaProjekti {
  id: string
  nimi: string
  varikoodi: string
  taustavari: string
}

export interface TositeListaRivi {
  id: string
  paivamaara: number | null
  toimittajanNimi: string | null
  lisatiedot: string
  maksutapa: Maksutapa | null
  summa: number | null
  projektinId?: string | null
  kasittelyKesken?: boolean
  onOstolasku?: boolean
  kansikuvaUrl?: string | null
  kuvia?: number
}

export type TositelistanEsitystapa = 'tiivis' | 'kuvilla' | 'kortit'

const ESITYSTAVAN_AVAIN = 'lemonaid.tositelistanEsitystapa'

export const lueTositelistanEsitystapa = (localStorageService: LocalStorageService): TositelistanEsitystapa => {
  const tallennettu = localStorageService.getFromLocalStorage<TositelistanEsitystapa>(ESITYSTAVAN_AVAIN)
  return tallennettu === 'tiivis' || tallennettu === 'kortit' ? tallennettu : 'kuvilla'
}

export const tallennaTositelistanEsitystapa = (localStorageService: LocalStorageService, esitystapa: TositelistanEsitystapa) => {
  localStorageService.setToLocalStorage(ESITYSTAVAN_AVAIN, esitystapa)
}

@Component({
  selector: 'app-tosite-lista',
  templateUrl: './tosite-lista.component.html',
  styleUrls: ['./tosite-lista.component.css'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TositeListaComponent {
  @Input() rivit: TositeListaRivi[] = []
  @Input() projektitMap: Map<string, TositeListaProjekti> = new Map()
  @Input() nykyinenSorttaus: Sort | null = null
  @Input() sorttausKaytossa = true
  @Input() esitystapa: TositelistanEsitystapa = 'kuvilla'
  @Output() riviKlikattu = new EventEmitter<string>()
  @Output() sorttausMuuttui = new EventEmitter<Sort>()

  get onkoProjektitKaytossa(): boolean {
    return this.projektitMap.size > 0
  }

  jarjesta(avain: string) {
    const uusiSuunta = this.nykyinenSorttaus?.active === avain ? (this.nykyinenSorttaus.direction === 'asc' ? 'desc' : 'asc') : avain === 'pvm' ? 'desc' : 'asc'

    this.sorttausMuuttui.emit({
      active: avain,
      direction: uusiSuunta,
    })
  }
}
